/* eslint-disable */
import React, {useState} from 'react';
//css
import 'contents/assets/scss/page/accounting.scss';
//component
import PopAmountEdit from '../../accounting/_PopAmountEdit';
import Tab from '../../../component/Inc/Tab';
import Calendar from '../../../component/Inc/Calendar';
import Modal from '../../../component/Inc/Modal';

function AccountingIncentiveDetail03() {
  const [tabIdx, setTabIdx] = useState(0);
  const [modalAmountEdit, setAmountEdit] = useState(false);
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  const [modalAlert, setModalAlert] = useState(0);
  const tab01 = [
    {title: '전체', value: 0},
    {title: '정산', value: 1},
    {title: '지급 대기', value: 2}
  ];
  return (
    <main className="com_container">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu8_7 active">
            인센티브 정산 관리 <span className="bar" />
            <span className="point_txt">홍담임 103</span>
          </h2>
        </section>
        <section className="com_pg_container p_incentive_detail">
          <div className="box full">
            <div className="com_board_list__top">
              <div className="board_select">
                <select className="select">
                  <option value="이지수능 (본사)">이지수능 (본사)</option>
                </select>
                <Tab data={tab01} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
              </div>
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <Calendar />
            <div className="com_board_list__top">
              <section className="com_board_search end">
                <div className="com_count_wrapper">
                  <div className="operators">
                    <div className="operators_label">
                      <span className="operators_count">총 정산 건수</span>
                      <span className="operators_value">98건</span>
                    </div>
                  </div>
                  <div className="turnover">
                    <div className="turnover_label">
                      <span className="turnover_count">총 정산 금액</span>
                      <span className="turnover_value">46,500,000</span>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="70" />
                <col width="100" />
                <col width="90" />
                <col width="90" />
                <col width="100" />
                <col width="105" />
                <col width="105" />
                <col width="105" />
                <col width="105" />
                <col width="105" />
                <col width="105" />
                <col width="105" />
                <col width="105" />
                <col width="105" />
                <col width="105" />
                <col width="105" />
              </colgroup>
              <thead>
                <tr>
                  <th>선택</th>
                  <th>학생명</th>
                  <th>소속</th>
                  <th>영역</th>
                  <th>회차 / T</th>
                  <th>상품가격</th>
                  <th>
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                    최근 입금일
                  </th>
                  <th>입금회차</th>
                  <th>진행 수업</th>
                  <th>입금 금액</th>
                  <th>환불 금액</th>
                  <th>최종 금액</th>
                  <th>홍보과목 수</th>
                  <th>
                    정산금액 
                    전달
                  </th>
                  <th>최종 정산금액</th>
                  <th>정산 상태</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input type="checkbox" id="chk01" className="com_chk" />
                    <label htmlFor="chk01" />
                  </td>
                  <td>
                    <button className="btn_link">김학생103</button>
                  </td>
                  <td>화상</td>
                  <td>과탐</td>
                  <td>48회 / 2T</td>
                  <td>46,650,000</td>
                  <td>2022, ,08, 25</td>
                  <td>16.5</td>
                  <td>8</td>
                  <td>1,000,000</td>
                  <td className="td_red">1,000</td>
                  <td className="td_point">78,000</td>
                  <td className="td_point">2</td>
                  <td>
                    홍교사103 <br />
                    5,000
                  </td>
                  <td className="td_point">78,000</td>
                  <td className="td_red">
                    <button className="btn_link txt">
                      정산대기
                    </button>
                  </td>
                </tr>
								<tr>
                  <td>
                    <input type="checkbox" id="chk01" className="com_chk" />
                    <label htmlFor="chk01" />
                  </td>
                  <td>
                    <button className="btn_link">김학생103</button>
                  </td>
                  <td>화상</td>
                  <td>과탐</td>
                  <td>48회 / 2T</td>
                  <td>46,650,000</td>
                  <td>2022, ,08, 25</td>
                  <td>16.5</td>
                  <td>8</td>
                  <td>1,000,000</td>
                  <td className="td_red">1,000</td>
                  <td className="td_point">78,000</td>
                  <td className="td_point">2</td>
                  <td>
                    홍교사103 <br />
                    5,000
                  </td>
                  <td className="td_point">78,000</td>
                  <td>
                    <button className="btn_link txt">
										정산 <br/>
										2023, 05, 12
                    </button>
                  </td>
                </tr>
								<tr>
                  <td>
                    <input type="checkbox" id="chk01" className="com_chk" />
                    <label htmlFor="chk01" />
                  </td>
                  <td>
                    <button className="btn_link">김학생103</button>
                  </td>
                  <td>화상</td>
                  <td>과탐</td>
                  <td>48회 / 2T</td>
                  <td>46,650,000</td>
                  <td>2022, ,08, 25</td>
                  <td>16.5</td>
                  <td>8</td>
                  <td>1,000,000</td>
                  <td className="td_red">1,000</td>
                  <td className="td_point">78,000</td>
                  <td className="td_point">2</td>
                  <td>
                    홍교사103 <br />
                    5,000
                  </td>
                  <td className="td_point">78,000</td>
                  <td className="td_point">
                    <button className="btn_link txt">
										지급완료 <br/>
										2023, 05, 12
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="com_board_list__bottom">
              <button
                onClick={() => {
                  setModalAlert(true);
                }}
                className="com_btn black xs"
              >
                선택항목 정산
              </button>
              <div>
                <button className="com_btn orange xs wl">저장</button>
                <button className="com_btn orange xs wl">수정</button>
              </div>
              <button className="com_btn black xs btn_down_orange">다운로드</button>
            </div>
          </div>
        </section>
      </div>
      <PopAmountEdit open={modalAmountEdit} close={() => setAmountEdit(false)} />
      <Modal open={modalAlert} close={() => setModalAlert(false)} type="type_alert">
        <div className="content_container">
          <div className="txt padding_bottom_no">선택항목을 정산 하시겠습니까?</div>
        </div>
        <div className="btn_container">
          <button className="com_btn lightGray xs">취소</button>
          <button className="com_btn orange xs">확인</button>
        </div>
      </Modal>
    </main>
  );
}

export default AccountingIncentiveDetail03;
